module.exports = __webpack_public_path__ + "img/SecurityAwareness.0661fe70.png";